import { l } from '@manychat/manyui'

import { DEFAULT_EMAIL } from 'apps/email/emailConstants'
import { isBusinessEmailValid } from 'apps/email/emailHelpers'
import { BusinessEmail } from 'shared/api/common/schemas/email'

export const getEmailNodeSenderName = ({
  nodeSenderName,
  companyName,
  selectedBusinessEmail,
}: {
  nodeSenderName: string | null
  companyName: string | null
  selectedBusinessEmail: BusinessEmail | null
}) => {
  if (!selectedBusinessEmail || !isBusinessEmailValid(selectedBusinessEmail)) {
    return l.translate('Invalid Business Email')
  }

  const senderName = nodeSenderName || selectedBusinessEmail.sender_name || companyName || ''
  const senderEmail = selectedBusinessEmail.email || DEFAULT_EMAIL
  return `${senderName} <${senderEmail}>`
}
